module.exports = __webpack_public_path__ + "img/project9_6.png.c295a2e5.webp";